module.exports = __webpack_public_path__ + "static/image/history/m/202112@3x.ver2_0_2.jpg?d34230c4";